import { sendEvent } from 'constants/mixpanelHelper';
import { CF_GEN_AI_EVENTS } from 'constants/trackingEvents';

export const CF_GEN_AI_BUTTON_TYPES = {
  HELP_ME_WRITE: 'Help me write',
  REPHRASE: 'Rephrase',
  REANALYZE: 'Reanalyze',
};

export const sendCFGenAIButtonClickedEvent = ({
  eventName = CF_GEN_AI_EVENTS.AI_BUTTON_CLICKED,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, purpose: 'CF' } });
};

export const sendCFGenAISuggestionUsedEvent = ({
  eventName = CF_GEN_AI_EVENTS.AI_SUGGESTION_USED,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, purpose: 'CF' } });
};
